import Colors from "modules/Colors"
import styled from 'styled-components'

export const StyledWarningDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 8px;
  background-color: ${Colors.PAPER_WARNING_CONTAINER};
`